/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DiscoverFeedTiles_viewer$ref = any;
type FeedSettings_viewer$ref = any;
export type DiscoveryFeed_viewer$ref = any;
export type DiscoveryFeed_viewer = {
    readonly discoveryFeed?: ReadonlyArray<{
        readonly ctaUrl: string | null;
        readonly ctaText: string | null;
        readonly description: string | null;
        readonly header: string | null;
        readonly imageUrl: string | null;
        readonly itemCreator: string | null;
        readonly itemId: string | null;
        readonly reasonMessage: string | null;
        readonly subtitle: string | null;
        readonly subtitleUrl: string | null;
        readonly tags: ReadonlyArray<{
            readonly name: string | null;
            readonly url: string | null;
        } | null> | null;
        readonly title: string | null;
        readonly titleUrl: string | null;
        readonly tileType: string | null;
    } | null> | null;
    readonly " $fragmentRefs": DiscoverFeedTiles_viewer$ref & FeedSettings_viewer$ref;
    readonly " $refType": DiscoveryFeed_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DiscoveryFeed_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DiscoverFeedTiles_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "FeedSettings_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "discoveryFeed",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "DiscoveryFeedTile",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ctaUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ctaText",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "header",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "imageUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "itemCreator",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "itemId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "reasonMessage",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtitle",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtitleUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tags",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DiscoveryFeedValue",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "titleUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "tileType",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '7b17b7d1526fc6824d413ab7e0e0513e';
export default node;
